/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AppRouteImport } from './routes/app'
import { Route as BusinessOnboardingRouteImport } from './routes/business-onboarding'
import { Route as DisclaimerRouteImport } from './routes/disclaimer'
import { Route as DiscoveryRouteImport } from './routes/discovery'
import { Route as EstimateWidgetForContractorsRouteImport } from './routes/estimate-widget-for-contractors'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as OnePagerRouteImport } from './routes/one-pager'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminLeadsRouteImport } from './routes/admin/leads'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AppCustomerIdRouteImport } from './routes/app/$customerId'
import { Route as DiscoveryIndexRouteImport } from './routes/discovery/index'
import { Route as DiscoveryPublicCustomerSlugRouteImport } from './routes/discovery/$publicCustomerSlug'
import { Route as AdminCompaniesIndexRouteImport } from './routes/admin/companies/index'
import { Route as AdminCompaniesCustomerIdRouteImport } from './routes/admin/companies/$customerId'
import { Route as AppCustomerIdIndexRouteImport } from './routes/app/$customerId/index'
import { Route as AppCustomerIdBuilderRouteImport } from './routes/app/$customerId/builder'
import { Route as AppCustomerIdJourneyRouteImport } from './routes/app/$customerId/journey'
import { Route as AppCustomerIdKnowledgeRouteImport } from './routes/app/$customerId/knowledge'
import { Route as AppCustomerIdLeadsRouteImport } from './routes/app/$customerId/leads'
import { Route as AppCustomerIdPricingRouteImport } from './routes/app/$customerId/pricing'
import { Route as AppCustomerIdSettingsRouteImport } from './routes/app/$customerId/settings'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const BusinessOnboardingRoute = BusinessOnboardingRouteImport.update({
  id: '/business-onboarding',
  path: '/business-onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const DisclaimerRoute = DisclaimerRouteImport.update({
  id: '/disclaimer',
  path: '/disclaimer',
  getParentRoute: () => rootRouteImport,
} as any)
const DiscoveryRoute = DiscoveryRouteImport.update({
  id: '/discovery',
  path: '/discovery',
  getParentRoute: () => rootRouteImport,
} as any)
const EstimateWidgetForContractorsRoute =
  EstimateWidgetForContractorsRouteImport.update({
    id: '/estimate-widget-for-contractors',
    path: '/estimate-widget-for-contractors',
    getParentRoute: () => rootRouteImport,
  } as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const OnePagerRoute = OnePagerRouteImport.update({
  id: '/one-pager',
  path: '/one-pager',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminLeadsRoute = AdminLeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => AdminRoute,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomerIdRoute = AppCustomerIdRouteImport.update({
  id: '/$customerId',
  path: '/$customerId',
  getParentRoute: () => AppRoute,
} as any)
const DiscoveryIndexRoute = DiscoveryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DiscoveryRoute,
} as any)
const DiscoveryPublicCustomerSlugRoute =
  DiscoveryPublicCustomerSlugRouteImport.update({
    id: '/$publicCustomerSlug',
    path: '/$publicCustomerSlug',
    getParentRoute: () => DiscoveryRoute,
  } as any)
const AdminCompaniesIndexRoute = AdminCompaniesIndexRouteImport.update({
  id: '/companies/',
  path: '/companies/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCompaniesCustomerIdRoute =
  AdminCompaniesCustomerIdRouteImport.update({
    id: '/companies/$customerId',
    path: '/companies/$customerId',
    getParentRoute: () => AdminRoute,
  } as any)
const AppCustomerIdIndexRoute = AppCustomerIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCustomerIdRoute,
} as any)
const AppCustomerIdBuilderRoute = AppCustomerIdBuilderRouteImport.update({
  id: '/builder',
  path: '/builder',
  getParentRoute: () => AppCustomerIdRoute,
} as any)
const AppCustomerIdJourneyRoute = AppCustomerIdJourneyRouteImport.update({
  id: '/journey',
  path: '/journey',
  getParentRoute: () => AppCustomerIdRoute,
} as any)
const AppCustomerIdKnowledgeRoute = AppCustomerIdKnowledgeRouteImport.update({
  id: '/knowledge',
  path: '/knowledge',
  getParentRoute: () => AppCustomerIdRoute,
} as any)
const AppCustomerIdLeadsRoute = AppCustomerIdLeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => AppCustomerIdRoute,
} as any)
const AppCustomerIdPricingRoute = AppCustomerIdPricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => AppCustomerIdRoute,
} as any)
const AppCustomerIdSettingsRoute = AppCustomerIdSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppCustomerIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/app': typeof AppRouteWithChildren
  '/business-onboarding': typeof BusinessOnboardingRoute
  '/disclaimer': typeof DisclaimerRoute
  '/discovery': typeof DiscoveryRouteWithChildren
  '/estimate-widget-for-contractors': typeof EstimateWidgetForContractorsRoute
  '/onboarding': typeof OnboardingRoute
  '/one-pager': typeof OnePagerRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/admin/leads': typeof AdminLeadsRoute
  '/app/$customerId': typeof AppCustomerIdRouteWithChildren
  '/discovery/$publicCustomerSlug': typeof DiscoveryPublicCustomerSlugRoute
  '/admin/': typeof AdminIndexRoute
  '/app/': typeof AppIndexRoute
  '/discovery/': typeof DiscoveryIndexRoute
  '/admin/companies/$customerId': typeof AdminCompaniesCustomerIdRoute
  '/app/$customerId/builder': typeof AppCustomerIdBuilderRoute
  '/app/$customerId/journey': typeof AppCustomerIdJourneyRoute
  '/app/$customerId/knowledge': typeof AppCustomerIdKnowledgeRoute
  '/app/$customerId/leads': typeof AppCustomerIdLeadsRoute
  '/app/$customerId/pricing': typeof AppCustomerIdPricingRoute
  '/app/$customerId/settings': typeof AppCustomerIdSettingsRoute
  '/admin/companies/': typeof AdminCompaniesIndexRoute
  '/app/$customerId/': typeof AppCustomerIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/business-onboarding': typeof BusinessOnboardingRoute
  '/disclaimer': typeof DisclaimerRoute
  '/estimate-widget-for-contractors': typeof EstimateWidgetForContractorsRoute
  '/onboarding': typeof OnboardingRoute
  '/one-pager': typeof OnePagerRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/admin/leads': typeof AdminLeadsRoute
  '/discovery/$publicCustomerSlug': typeof DiscoveryPublicCustomerSlugRoute
  '/admin': typeof AdminIndexRoute
  '/app': typeof AppIndexRoute
  '/discovery': typeof DiscoveryIndexRoute
  '/admin/companies/$customerId': typeof AdminCompaniesCustomerIdRoute
  '/app/$customerId/builder': typeof AppCustomerIdBuilderRoute
  '/app/$customerId/journey': typeof AppCustomerIdJourneyRoute
  '/app/$customerId/knowledge': typeof AppCustomerIdKnowledgeRoute
  '/app/$customerId/leads': typeof AppCustomerIdLeadsRoute
  '/app/$customerId/pricing': typeof AppCustomerIdPricingRoute
  '/app/$customerId/settings': typeof AppCustomerIdSettingsRoute
  '/admin/companies': typeof AdminCompaniesIndexRoute
  '/app/$customerId': typeof AppCustomerIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/app': typeof AppRouteWithChildren
  '/business-onboarding': typeof BusinessOnboardingRoute
  '/disclaimer': typeof DisclaimerRoute
  '/discovery': typeof DiscoveryRouteWithChildren
  '/estimate-widget-for-contractors': typeof EstimateWidgetForContractorsRoute
  '/onboarding': typeof OnboardingRoute
  '/one-pager': typeof OnePagerRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/admin/leads': typeof AdminLeadsRoute
  '/app/$customerId': typeof AppCustomerIdRouteWithChildren
  '/discovery/$publicCustomerSlug': typeof DiscoveryPublicCustomerSlugRoute
  '/admin/': typeof AdminIndexRoute
  '/app/': typeof AppIndexRoute
  '/discovery/': typeof DiscoveryIndexRoute
  '/admin/companies/$customerId': typeof AdminCompaniesCustomerIdRoute
  '/app/$customerId/builder': typeof AppCustomerIdBuilderRoute
  '/app/$customerId/journey': typeof AppCustomerIdJourneyRoute
  '/app/$customerId/knowledge': typeof AppCustomerIdKnowledgeRoute
  '/app/$customerId/leads': typeof AppCustomerIdLeadsRoute
  '/app/$customerId/pricing': typeof AppCustomerIdPricingRoute
  '/app/$customerId/settings': typeof AppCustomerIdSettingsRoute
  '/admin/companies/': typeof AdminCompaniesIndexRoute
  '/app/$customerId/': typeof AppCustomerIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/app'
    | '/business-onboarding'
    | '/disclaimer'
    | '/discovery'
    | '/estimate-widget-for-contractors'
    | '/onboarding'
    | '/one-pager'
    | '/privacy'
    | '/terms'
    | '/admin/leads'
    | '/app/$customerId'
    | '/discovery/$publicCustomerSlug'
    | '/admin/'
    | '/app/'
    | '/discovery/'
    | '/admin/companies/$customerId'
    | '/app/$customerId/builder'
    | '/app/$customerId/journey'
    | '/app/$customerId/knowledge'
    | '/app/$customerId/leads'
    | '/app/$customerId/pricing'
    | '/app/$customerId/settings'
    | '/admin/companies/'
    | '/app/$customerId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/business-onboarding'
    | '/disclaimer'
    | '/estimate-widget-for-contractors'
    | '/onboarding'
    | '/one-pager'
    | '/privacy'
    | '/terms'
    | '/admin/leads'
    | '/discovery/$publicCustomerSlug'
    | '/admin'
    | '/app'
    | '/discovery'
    | '/admin/companies/$customerId'
    | '/app/$customerId/builder'
    | '/app/$customerId/journey'
    | '/app/$customerId/knowledge'
    | '/app/$customerId/leads'
    | '/app/$customerId/pricing'
    | '/app/$customerId/settings'
    | '/admin/companies'
    | '/app/$customerId'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/app'
    | '/business-onboarding'
    | '/disclaimer'
    | '/discovery'
    | '/estimate-widget-for-contractors'
    | '/onboarding'
    | '/one-pager'
    | '/privacy'
    | '/terms'
    | '/admin/leads'
    | '/app/$customerId'
    | '/discovery/$publicCustomerSlug'
    | '/admin/'
    | '/app/'
    | '/discovery/'
    | '/admin/companies/$customerId'
    | '/app/$customerId/builder'
    | '/app/$customerId/journey'
    | '/app/$customerId/knowledge'
    | '/app/$customerId/leads'
    | '/app/$customerId/pricing'
    | '/app/$customerId/settings'
    | '/admin/companies/'
    | '/app/$customerId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  AppRoute: typeof AppRouteWithChildren
  BusinessOnboardingRoute: typeof BusinessOnboardingRoute
  DisclaimerRoute: typeof DisclaimerRoute
  DiscoveryRoute: typeof DiscoveryRouteWithChildren
  EstimateWidgetForContractorsRoute: typeof EstimateWidgetForContractorsRoute
  OnboardingRoute: typeof OnboardingRoute
  OnePagerRoute: typeof OnePagerRoute
  PrivacyRoute: typeof PrivacyRoute
  TermsRoute: typeof TermsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business-onboarding': {
      id: '/business-onboarding'
      path: '/business-onboarding'
      fullPath: '/business-onboarding'
      preLoaderRoute: typeof BusinessOnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/disclaimer': {
      id: '/disclaimer'
      path: '/disclaimer'
      fullPath: '/disclaimer'
      preLoaderRoute: typeof DisclaimerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/discovery': {
      id: '/discovery'
      path: '/discovery'
      fullPath: '/discovery'
      preLoaderRoute: typeof DiscoveryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estimate-widget-for-contractors': {
      id: '/estimate-widget-for-contractors'
      path: '/estimate-widget-for-contractors'
      fullPath: '/estimate-widget-for-contractors'
      preLoaderRoute: typeof EstimateWidgetForContractorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/one-pager': {
      id: '/one-pager'
      path: '/one-pager'
      fullPath: '/one-pager'
      preLoaderRoute: typeof OnePagerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/leads': {
      id: '/admin/leads'
      path: '/leads'
      fullPath: '/admin/leads'
      preLoaderRoute: typeof AdminLeadsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/$customerId': {
      id: '/app/$customerId'
      path: '/$customerId'
      fullPath: '/app/$customerId'
      preLoaderRoute: typeof AppCustomerIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/discovery/': {
      id: '/discovery/'
      path: '/'
      fullPath: '/discovery/'
      preLoaderRoute: typeof DiscoveryIndexRouteImport
      parentRoute: typeof DiscoveryRoute
    }
    '/discovery/$publicCustomerSlug': {
      id: '/discovery/$publicCustomerSlug'
      path: '/$publicCustomerSlug'
      fullPath: '/discovery/$publicCustomerSlug'
      preLoaderRoute: typeof DiscoveryPublicCustomerSlugRouteImport
      parentRoute: typeof DiscoveryRoute
    }
    '/admin/companies/': {
      id: '/admin/companies/'
      path: '/companies'
      fullPath: '/admin/companies/'
      preLoaderRoute: typeof AdminCompaniesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/companies/$customerId': {
      id: '/admin/companies/$customerId'
      path: '/companies/$customerId'
      fullPath: '/admin/companies/$customerId'
      preLoaderRoute: typeof AdminCompaniesCustomerIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/app/$customerId/': {
      id: '/app/$customerId/'
      path: '/'
      fullPath: '/app/$customerId/'
      preLoaderRoute: typeof AppCustomerIdIndexRouteImport
      parentRoute: typeof AppCustomerIdRoute
    }
    '/app/$customerId/builder': {
      id: '/app/$customerId/builder'
      path: '/builder'
      fullPath: '/app/$customerId/builder'
      preLoaderRoute: typeof AppCustomerIdBuilderRouteImport
      parentRoute: typeof AppCustomerIdRoute
    }
    '/app/$customerId/journey': {
      id: '/app/$customerId/journey'
      path: '/journey'
      fullPath: '/app/$customerId/journey'
      preLoaderRoute: typeof AppCustomerIdJourneyRouteImport
      parentRoute: typeof AppCustomerIdRoute
    }
    '/app/$customerId/knowledge': {
      id: '/app/$customerId/knowledge'
      path: '/knowledge'
      fullPath: '/app/$customerId/knowledge'
      preLoaderRoute: typeof AppCustomerIdKnowledgeRouteImport
      parentRoute: typeof AppCustomerIdRoute
    }
    '/app/$customerId/leads': {
      id: '/app/$customerId/leads'
      path: '/leads'
      fullPath: '/app/$customerId/leads'
      preLoaderRoute: typeof AppCustomerIdLeadsRouteImport
      parentRoute: typeof AppCustomerIdRoute
    }
    '/app/$customerId/pricing': {
      id: '/app/$customerId/pricing'
      path: '/pricing'
      fullPath: '/app/$customerId/pricing'
      preLoaderRoute: typeof AppCustomerIdPricingRouteImport
      parentRoute: typeof AppCustomerIdRoute
    }
    '/app/$customerId/settings': {
      id: '/app/$customerId/settings'
      path: '/settings'
      fullPath: '/app/$customerId/settings'
      preLoaderRoute: typeof AppCustomerIdSettingsRouteImport
      parentRoute: typeof AppCustomerIdRoute
    }
  }
}

interface AdminRouteChildren {
  AdminLeadsRoute: typeof AdminLeadsRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminCompaniesCustomerIdRoute: typeof AdminCompaniesCustomerIdRoute
  AdminCompaniesIndexRoute: typeof AdminCompaniesIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminLeadsRoute: AdminLeadsRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminCompaniesCustomerIdRoute: AdminCompaniesCustomerIdRoute,
  AdminCompaniesIndexRoute: AdminCompaniesIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface AppCustomerIdRouteChildren {
  AppCustomerIdBuilderRoute: typeof AppCustomerIdBuilderRoute
  AppCustomerIdJourneyRoute: typeof AppCustomerIdJourneyRoute
  AppCustomerIdKnowledgeRoute: typeof AppCustomerIdKnowledgeRoute
  AppCustomerIdLeadsRoute: typeof AppCustomerIdLeadsRoute
  AppCustomerIdPricingRoute: typeof AppCustomerIdPricingRoute
  AppCustomerIdSettingsRoute: typeof AppCustomerIdSettingsRoute
  AppCustomerIdIndexRoute: typeof AppCustomerIdIndexRoute
}

const AppCustomerIdRouteChildren: AppCustomerIdRouteChildren = {
  AppCustomerIdBuilderRoute: AppCustomerIdBuilderRoute,
  AppCustomerIdJourneyRoute: AppCustomerIdJourneyRoute,
  AppCustomerIdKnowledgeRoute: AppCustomerIdKnowledgeRoute,
  AppCustomerIdLeadsRoute: AppCustomerIdLeadsRoute,
  AppCustomerIdPricingRoute: AppCustomerIdPricingRoute,
  AppCustomerIdSettingsRoute: AppCustomerIdSettingsRoute,
  AppCustomerIdIndexRoute: AppCustomerIdIndexRoute,
}

const AppCustomerIdRouteWithChildren = AppCustomerIdRoute._addFileChildren(
  AppCustomerIdRouteChildren,
)

interface AppRouteChildren {
  AppCustomerIdRoute: typeof AppCustomerIdRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppCustomerIdRoute: AppCustomerIdRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface DiscoveryRouteChildren {
  DiscoveryPublicCustomerSlugRoute: typeof DiscoveryPublicCustomerSlugRoute
  DiscoveryIndexRoute: typeof DiscoveryIndexRoute
}

const DiscoveryRouteChildren: DiscoveryRouteChildren = {
  DiscoveryPublicCustomerSlugRoute: DiscoveryPublicCustomerSlugRoute,
  DiscoveryIndexRoute: DiscoveryIndexRoute,
}

const DiscoveryRouteWithChildren = DiscoveryRoute._addFileChildren(
  DiscoveryRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  AppRoute: AppRouteWithChildren,
  BusinessOnboardingRoute: BusinessOnboardingRoute,
  DisclaimerRoute: DisclaimerRoute,
  DiscoveryRoute: DiscoveryRouteWithChildren,
  EstimateWidgetForContractorsRoute: EstimateWidgetForContractorsRoute,
  OnboardingRoute: OnboardingRoute,
  OnePagerRoute: OnePagerRoute,
  PrivacyRoute: PrivacyRoute,
  TermsRoute: TermsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
